"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoiceChatComponent = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const ConversationAgentService_1 = __importStar(require("@front/services/conversation/ConversationAgentService"));
const IAvatar_1 = __importDefault(require("@back/models/interfaces/IAvatar"));
const chatSettings_types_1 = require("@front/types/chatSettings.types");
const component_1 = require("@front/layouts/default-layout/component");
const component_2 = require("@front/components/notifications/component");
const trans_1 = require("../../../../common/translations/trans");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
const audio_analysis_helper_1 = require("./helpers/audio-analysis.helper");
const recording_management_helper_1 = require("./helpers/recording-management.helper");
const response_audio_playback_helper_1 = require("./helpers/response-audio-playback.helper");
const azure_voices_helper_1 = require("./helpers/azure-voices.helper");
//@ts-ignore                
let rwsTemplate = T.html `<div class="live-chat" ?disabled="${x => x.isLoading || x.isConnecting}">
    <div class="card p-4 text-center">    
        <div class="backdrop d-flex flex-column justify-content-between">            
            
            ${(0, fast_element_1.when)(x => x.isConnecting, (0, fast_element_1.html) `
                <div class="connection-status">
                    <app-loader></app-loader>
                    <p class="text-white mt-2">${'conversation.connecting'.t()}</p>
                </div>
            `)}
            
            
            <div class="chat-interface" ?hidden="${x => x.isConnecting || !x.isConversationActive}">
                
                
                <div class="mic-container" ?hidden="${x => x.isThinking || x.isSpeaking}">
                    
                    <div class="mic-icon-container ${x => x.isRecording ? 'recording' : ''}">
                        <div class="pulse-ring" id="pulse"></div>
                        <i class="simple-icon-microphone" id="micIcon"></i>
                    </div>
                    
                    
                    <div class="transcription-display" ?hidden="${x => !x.currentTranscription}">
                        <div class="transcription-text ${x => x.partialTranscription ? 'partial' : 'final'} ${x => x.isSpeaking ? 'interruption' : ''}">
                            ${x => x.currentTranscription}
                        </div>
                        ${(0, fast_element_1.when)(x => x.isSpeaking && x.partialTranscription, (0, fast_element_1.html) `
                            <div class="interruption-hint">${'conversation.interruption.active'.t()}</div>
                        `)}
                    </div>
                </div>
                
                
                <div class="thinking-status text-center" ?hidden="${x => !x.isThinking}">
                    <app-loader block="true"></app-loader>
                    <p class="mt-2">${'conversation.agent.thinking'.t()}</p>
                </div>
                
                
                <div id="equalizer" class="text-center pb-2${x => x.isSpeaking ? ' show' : ''}">
                    <svg class="equalizer mt-2" viewBox="0 0 140 80" width="140" height="80">
                        <rect class="eq_bar" x="0" y="${x => x.baseY - x.equalizerLevels[0]}" width="20" height="${x => x.equalizerLevels[0]}"></rect>
                        <rect class="eq_bar" x="30" y="${x => x.baseY - x.equalizerLevels[1]}" width="20" height="${x => x.equalizerLevels[1]}"></rect>
                        <rect class="eq_bar" x="60" y="${x => x.baseY - x.equalizerLevels[2]}" width="20" height="${x => x.equalizerLevels[2]}"></rect>
                        <rect class="eq_bar" x="90" y="${x => x.baseY - x.equalizerLevels[3]}" width="20" height="${x => x.equalizerLevels[3]}"></rect>
                        <rect class="eq_bar" x="120" y="${x => x.baseY - x.equalizerLevels[4]}" width="20" height="${x => x.equalizerLevels[4]}"></rect>
                    </svg>
                </div>
            </div>
        </div>
        <div class="close-voice">
            <button @click="${x => x.endConversation('manual')}" class="btn btn-danger" ?disabled="${x => false}"><i class="simple-icon-close"></i></button>
        </div>
    </div>


    
    <div hidden class="conversation-controls">
        
        <div class="connection-controls">
            <button class="btn btn-primary connection-btn"
                @click="${x => x.isConversationActive ? x.endConversation('manual') : x.startConversation()}"
                ?disabled="${x => x.isLoading || !x.isReady}">
                ${(0, fast_element_1.when)(x => x.isConversationActive, (0, fast_element_1.html) `${'conversation.end'.t()}`)}
                ${(0, fast_element_1.when)(x => !x.isConversationActive, (0, fast_element_1.html) `${'conversation.start'.t()}`)}
            </button>
        </div>

        
        <div class="input-controls" ?hidden="${x => !x.isConversationActive}">
            
            <div class="recording-status">
                <div class="recording-indicator ${x => x.isRecording ? 'active' : 'inactive'}">
                    <span class="recording-icon">${x => x.isRecording ? '🔴' : '⚫'}</span>
                    <span class="recording-text">
                        ${(0, fast_element_1.when)(x => x.isRecording, (0, fast_element_1.html) `${'conversation.recording.active'.t()}`)}
                        ${(0, fast_element_1.when)(x => !x.isRecording, (0, fast_element_1.html) `${'conversation.recording.inactive'.t()}`)}
                    </span>
                </div>

                <div class="audio-status" ?hidden="${x => !x.isSpeaking}">
                    <span class="speaking-indicator">🔊</span>
                    <span>${'conversation.agent.speaking'.t()}</span>
                </div>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: block;
  width: 100%;
  margin: 0 0 0.5rem 0;
  flex-shrink: 0;
  padding-top: 15px;
}

.live-chat {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 60px;
  margin: 0;
  background: white;
  border: 1px solid #ced4da;
  border-radius: 0.375rem;
  overflow: hidden;
  box-sizing: border-box;
}
.live-chat[disabled] {
  opacity: 0.65;
  pointer-events: none;
  background: #f8f9fa;
}
.live-chat > .card {
  display: flex;
  height: 100%;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0.5rem;
  margin: 0;
}
.live-chat .close-voice {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 101;
}
.live-chat .close-voice .btn {
  padding: 4px 8px;
  font-size: 0.875rem;
  line-height: 1;
  border-radius: 0.25rem;
  min-height: auto;
}
.live-chat .azure-voice-controls {
  background: rgba(248, 249, 250, 0.9);
  border-radius: 0.375rem;
  padding: 0.5rem;
  backdrop-filter: none;
}
.live-chat .azure-voice-controls .voice-select {
  background-color: white;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: var(--primary-color);
  padding: 0.25rem 0.5rem;
}
.live-chat .azure-voice-controls .voice-select:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  border-color: #80bdff;
  outline: 0;
}
.live-chat .azure-voice-controls .voice-select:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  background-color: #e9ecef;
}
.live-chat .azure-voice-controls .voice-select option {
  color: var(--primary-color);
  background: white;
}
.live-chat .azure-voice-controls .voice-filters .btn {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
  border: 1px solid #ced4da;
  color: var(--primary-color);
  background: white;
}
.live-chat .azure-voice-controls .voice-filters .btn:hover:not(:disabled) {
  background-color: #e9ecef;
  border-color: #adb5bd;
  color: var(--primary-color);
}
.live-chat .azure-voice-controls .voice-filters .btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.backdrop {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 48px;
  position: relative;
}

.connection-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 48px;
}
.connection-status p {
  margin: 0.25rem 0 0 0;
  font-size: 0.8rem;
  color: var(--primary-color);
  font-weight: 500;
}

.chat-interface {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 48px;
}

.thinking-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 48px;
}
.thinking-status p {
  margin: 0.25rem 0 0 0;
  font-size: 0.8rem;
  color: var(--primary-color);
  font-weight: 500;
}

#equalizer {
  opacity: 0;
  display: none;
  transition: opacity 0.3s ease-in-out;
  height: auto;
  align-items: center;
  justify-content: center;
  margin-top: 0.5rem;
}
#equalizer.show {
  display: flex;
  opacity: 1;
}
#equalizer .equalizer {
  max-width: 120px;
  width: 100%;
  height: 32px;
}
#equalizer .equalizer rect {
  fill: #6c757d;
  rx: 2;
}

.mic-container {
  position: relative;
  width: 40px;
  height: 40px;
  margin: 0.25rem auto;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}
.mic-container .mic-icon-container {
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #6c757d;
  color: white;
  transition: all 0.3s ease;
}
.mic-container .mic-icon-container.recording {
  background: #28a745;
}
.mic-container .mic-icon-container.recording .pulse-ring {
  border-color: #28a745;
  animation: pulse 2s infinite;
}
.mic-container .mic-icon-container .pulse-ring {
  position: absolute;
  border: 2px solid #6c757d;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  opacity: 0;
}
.mic-container .mic-icon-container #micIcon {
  font-size: 1rem;
  z-index: 2;
}
.mic-container .transcription-display {
  position: absolute;
  top: 50%;
  left: 50px;
  transform: translateY(-50%);
  width: 200px;
  max-width: 60vw;
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.5rem 0.75rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 10;
  transition: all 0.3s ease;
}
.mic-container .transcription-display .transcription-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--primary-color);
  min-height: 1.2rem;
  text-align: left;
  transition: opacity 0.2s ease;
}
.mic-container .transcription-display .transcription-text.partial {
  opacity: 0.7;
  font-style: italic;
}
.mic-container .transcription-display .transcription-text.partial::after {
  content: "...";
  animation: blink 1s infinite;
}
.mic-container .transcription-display .transcription-text.final {
  opacity: 1;
  font-weight: 500;
}
.mic-container .transcription-display .transcription-text.interruption {
  color: #dc3545;
  font-weight: 600;
  border-left: 3px solid #dc3545;
  padding-left: 0.5rem;
}
.mic-container .transcription-display .interruption-hint {
  font-size: 0.75rem;
  color: #dc3545;
  font-style: italic;
  margin-top: 0.25rem;
  opacity: 0.8;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
@media (max-width: 576px) {
  .mic-container {
    width: 32px;
    height: 32px;
  }
  .mic-container .mic-icon-container {
    width: 28px;
    height: 28px;
  }
  .mic-container .mic-icon-container .pulse-ring {
    width: 36px;
    height: 36px;
  }
  .mic-container .mic-icon-container #micIcon {
    font-size: 0.875rem;
  }
  .mic-container .transcription-display {
    left: 38px;
    width: 180px;
    padding: 0.375rem 0.5rem;
  }
  .mic-container .transcription-display .transcription-text {
    font-size: 0.8rem;
  }
  #equalizer .equalizer {
    max-width: 100px;
    height: 28px;
  }
}`;
const shadowOptions = { "mode": "open" };
let VoiceChatComponent = class VoiceChatComponent extends client_1.RWSViewComponent {
    // Computed properties for template
    get modelId() {
        // Return the model if provided, otherwise return empty string
        // Don't provide any defaults - parent must provide either model or avatar
        return this.model || '';
    }
    get hasValidSelection() {
        // We need either a model OR an avatar to proceed
        return !!(this.model || this.avatar);
    }
    constructor(conversationAgentService, api, storageService) {
        super();
        this.conversationAgentService = conversationAgentService;
        this.api = api;
        this.storageService = storageService;
        this.conversationId = '';
        this.language = (0, trans_1.getCurrentLanguage)();
        this.knowledgeIds = ''; // JSON string of knowledge IDs
        this.writingStyleIds = ''; // JSON string of writing style IDs
        this.promptSlots = ''; // JSON string of prompt slots
        this.avatarSelected = null;
        this.isConnected = false;
        this.isConversationActive = false;
        this.isRecording = false;
        this.isSpeaking = false;
        this.isLoading = false;
        this.messages = [];
        this.currentSessionId = null;
        this.currentConversationId = null; // Store conversation ID for restart
        this.errorMessage = '';
        this.volume = 0.8;
        this.isReady = false;
        this.isVoiceStreaming = false;
        this.userTranscriptions = [];
        this.currentTranscription = '';
        this.partialTranscription = false;
        this.isConnecting = false;
        this.chatSettings = chatSettings_types_1.DEFAULT_CHAT_SETTINGS;
        this.userTurn = false;
        this.isThinking = false;
        this.agentSpeaking = false;
        this.baseY = 60;
        this.equalizerLevels = [10, 20, 30, 40, 50];
        this.connectionCheckInterval = null;
        this.audioContext = null;
        this.analyserNode = null;
        this.equalizerAnimationFrame = null;
        this.dataArray = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Set connecting state initially
        this.isConnecting = true;
        // Initialize conversation services once
        this.conversationAgentService.init(this);
        // Update language from current translation system language
        const currentLang = (0, trans_1.getCurrentLanguage)();
        if (currentLang && currentLang !== this.language) {
            this.language = currentLang;
        }
        // Load chat settings from storage
        await this.loadChatSettings();
        await this.loadAvatar();
        this.setupConversationCallbacks();
        if (this.conversationAgentService.isWsConnected()) {
            this.isConnected = true;
            // Keep isConnecting = true until conversation is ready
        }
        this.updateIsReady();
        if (this.isConnected) {
            this.startConversation();
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        // End active conversation first
        if (this.isConversationActive) {
            this.endConversation('component_destroyed');
            this.emitEnd();
        }
        // Clean up all resources
        this.cleanupMediaDevices();
        this.cleanup();
        // Stop audio analysis
        audio_analysis_helper_1.AudioAnalysisHelper.stopAudioAnalysis(this);
        // Remove speaking callback
        this.conversationAgentService.removeOnSpeakingChanged();
        // Clean up connection monitoring interval
        if (this.connectionCheckInterval) {
            clearInterval(this.connectionCheckInterval);
            this.connectionCheckInterval = null;
        }
    }
    async loadChatSettings() {
        try {
            const savedSettings = this.storageService.get('ai.chatSettings');
            if (savedSettings) {
                const parsedSettings = JSON.parse(savedSettings);
                this.chatSettings = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS, ...parsedSettings };
            }
            else {
                this.chatSettings = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS };
            }
        }
        catch (error) {
            console.error('Failed to load chat settings:', error);
            this.chatSettings = { ...chatSettings_types_1.DEFAULT_CHAT_SETTINGS };
        }
    }
    async loadAvatar() {
        if (!this.avatar)
            return;
        try {
            const response = await this.api.back.get('avatar.get', {
                routeParams: { id: this.avatar }
            });
            if (response.success && response.data) {
                this.avatarSelected = response.data;
            }
        }
        catch (error) {
            console.error('Failed to load avatar:', error);
        }
    }
    setupConversationCallbacks() {
        // Don't call init() here - it should only be called once in connectedCallback
        // Set up speaking status callback
        this.conversationAgentService.setOnSpeakingChanged(async (isSpeaking) => {
            await response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleSpeakingChanged(this, isSpeaking);
            // Update agent speaking state
            this.agentSpeaking = isSpeaking;
            this.isSpeaking = isSpeaking; // Keep this for backward compatibility
            if (isSpeaking) { // Agent started speaking
                console.log('🔊 [VoiceChat] Agent started speaking - audio analysis enabled');
                audio_analysis_helper_1.AudioAnalysisHelper.startAudioAnalysis(this);
                // STT session management is now handled in ResponseAudioPlaybackHelper
            }
            else { // Agent stopped speaking
                console.log('🔇 [VoiceChat] Agent stopped speaking');
                audio_analysis_helper_1.AudioAnalysisHelper.stopAudioAnalysis(this);
                // Clear any lingering transcriptions when agent stops
                recording_management_helper_1.RecordingManagementHelper.clearTranscriptionState(this);
                // Session state is managed in ResponseAudioPlaybackHelper
            }
        });
        // Monitor WebSocket connection status
        this.monitorWebSocketConnection();
    }
    monitorWebSocketConnection() {
        if (this.connectionCheckInterval) {
            clearInterval(this.connectionCheckInterval);
        }
        this.connectionCheckInterval = setInterval(() => {
            if (!this.conversationAgentService.isWsConnected()) {
                this.isConnected = false;
                this.isConnecting = true;
                this.updateIsReady();
                // Try to reconnect
                try {
                    // Attempt basic reconnection if supported by the service
                    this.isConnected = false;
                    this.updateIsReady();
                }
                catch (error) {
                    // Reconnection failed, will try again in next interval
                }
            }
            else if (!this.isConnected) {
                this.isConnected = true;
                // Don't set isConnecting = false here, wait for conversation to start
                this.updateIsReady();
            }
        }, 5000); // Check every 5 seconds
    }
    async startConversation(overrideParams) {
        var _a;
        if (this.isConversationActive && !(overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.conversationId)) {
            console.log('⚠️ [VoiceChat] Conversation already active, skipping start');
            return;
        }
        // Use override params if provided (for restart)
        const avatar = (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.avatar) || this.avatar;
        const model = (overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.model) || this.model;
        const hasValidSelection = (_a = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.hasValidSelection) !== null && _a !== void 0 ? _a : this.hasValidSelection;
        const conversationId = overrideParams === null || overrideParams === void 0 ? void 0 : overrideParams.conversationId;
        // Debug current state
        console.log('🔍 [VoiceChat] Starting conversation with:', {
            avatar,
            model,
            hasValidSelection,
            voice: this.chatSettings.voice,
            existingConversationId: conversationId
        });
        // Validate that we have either model or avatar
        if (!hasValidSelection) {
            this.errorMessage = 'voice-chat.error.noModelOrAvatar'.t();
            console.error('❌ [VoiceChat] No model or avatar provided');
            return;
        }
        this.isLoading = true;
        this.errorMessage = '';
        this.updateIsReady();
        try {
            // Parse JSON attributes
            let knowledgeIds = [];
            let writingStyleIds = [];
            let promptSlots = null;
            try {
                if (this.knowledgeIds) {
                    knowledgeIds = JSON.parse(this.knowledgeIds);
                }
            }
            catch (e) {
                console.warn('Failed to parse knowledgeIds:', e);
            }
            try {
                if (this.writingStyleIds) {
                    writingStyleIds = JSON.parse(this.writingStyleIds);
                }
            }
            catch (e) {
                console.warn('Failed to parse writingStyleIds:', e);
            }
            try {
                if (this.promptSlots) {
                    promptSlots = JSON.parse(this.promptSlots);
                }
            }
            catch (e) {
                console.warn('Failed to parse promptSlots:', e);
            }
            // Prepare conversation parameters
            const conversationParams = {
                avatarId: avatar,
                language: this.language,
                voice: this.chatSettings.voice,
                model: this.modelId,
                userId: component_1.DefaultLayout.USER.id,
                conversationId: conversationId, // REUSE EXISTING CONVERSATION ID FOR RESTART
                chatSettings: this.chatSettings, // Pass chat settings
                knowledgeIds: knowledgeIds, // Pass knowledge IDs
                writingStyleIds: writingStyleIds, // Pass writing style IDs
                promptSlots: promptSlots // Pass prompt slots
            };
            console.log('🔍 [VoiceChat] Conversation params:', {
                ...conversationParams,
                reusingConversation: !!conversationId
            });
            // Start conversation with callbacks
            const tempKey = await this.conversationAgentService.startConversation(conversationParams, {
                onResponse: (response) => {
                    if (!response.responseAudio) {
                        response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleConversationResponse(this, response);
                    }
                },
                onError: (error) => response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleConversationError(this, { data: { error } }),
                onSessionStarted: async (sessionId, conversationId) => {
                    this.currentSessionId = sessionId;
                    const isNewConversation = !this.currentConversationId;
                    this.currentConversationId = Number(conversationId); // CRITICAL: Store conversation ID for restart
                    this.isConversationActive = true;
                    this.isConnecting = false; // Now we're ready to listen for audio
                    console.log('🔍 [VoiceChat] Session started - sessionId:', sessionId);
                    console.log('🔍 [VoiceChat] Session started - conversationId:', conversationId);
                    console.log('🔍 [VoiceChat] Is new conversation:', isNewConversation);
                    if (!conversationId) {
                        console.error('❌ [VoiceChat] Backend did not provide conversation ID!');
                    }
                    this.userTurn = true;
                    this.isThinking = false;
                    this.isSpeaking = false;
                    this.updateIsReady();
                    if (isNewConversation && conversationId) {
                        console.log('🆕 [VoiceChat] NEW conversation - emitting start event');
                        this.$emit('chat:conversation:start', { conversationId });
                    }
                    else {
                        console.log('🔄 [VoiceChat] REUSING existing conversation - NOT emitting start event');
                    }
                    // Automatically start recording when conversation starts
                    await this.startRecording();
                },
                onSessionEnded: () => this.handleConversationEnd({}),
                onStatusChange: (status) => this.handleStatusChange(status),
                onUserTranscription: async (transcription) => {
                    await recording_management_helper_1.RecordingManagementHelper.handleUserTranscription(this, transcription);
                },
                onPartialTranscription: (transcription) => {
                    console.log('📝 [VoiceChat] Partial transcription received:', transcription, 'Agent speaking:', this.agentSpeaking);
                    recording_management_helper_1.RecordingManagementHelper.handlePartialTranscription(this, transcription);
                    // Interrupt agent speech if user starts speaking during agent response
                    if (this.agentSpeaking && transcription && transcription.trim()) {
                        console.log('🚫 [VoiceChat] User interruption detected during agent speech:', transcription);
                        this.conversationAgentService.interruptPlayback();
                        this.isSpeaking = false;
                        this.agentSpeaking = false;
                        this.userTurn = true;
                        this.isThinking = false;
                    }
                },
                onAudioResponse: (response) => {
                    response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleAudioResponse(this, response);
                    response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleConversationResponse(this, response);
                    if (response.response && response.response.trim()) {
                        recording_management_helper_1.RecordingManagementHelper.addMessage(this, 'assistant', response.response);
                    }
                },
                onTextResponse: (response) => response_audio_playback_helper_1.ResponseAudioPlaybackHelper.handleTextResponse(this, response),
                onConversationMessage: (message) => {
                    // Handle messages sent from backend for display
                    if (message.role && message.content) {
                        recording_management_helper_1.RecordingManagementHelper.addMessage(this, message.role, message.content);
                    }
                },
            });
            if (!tempKey) {
                throw new Error('Failed to start conversation agent');
            }
            // Note: currentSessionId will be set when onSessionStarted callback is called with the real backend session ID
        }
        catch (error) {
            console.error('Failed to start conversation:', error);
            this.errorMessage = error.message || 'conversation.start.failed'.t();
            this.updateIsReady();
            component_2.NotificationsArea.sendNotification({
                content: this.errorMessage,
                type: 'error'
            });
        }
        finally {
            this.isLoading = false;
        }
    }
    async endConversation(reason = 'unknown') {
        if (!this.isConversationActive || !this.currentSessionId) {
            console.log('⚠️ [VoiceChat] No active conversation to end');
            return;
        }
        this.isLoading = true;
        // Store the session ID for cleanup confirmation
        const sessionToEnd = this.currentSessionId;
        try {
            // IMMEDIATELY stop microphone streaming to prevent audio chunk spam
            console.log('🛑 [VoiceChat] IMMEDIATELY stopping microphone streaming');
            if (this.isRecording) {
                await this.conversationAgentService.stopAudioStreaming(sessionToEnd);
                this.isRecording = false;
                console.log('✅ [VoiceChat] Microphone streaming stopped');
            }
            // Stop voice streaming first with explicit wait
            if (this.isRecording) {
                await recording_management_helper_1.RecordingManagementHelper.stopRecording(this);
                // Add a small delay to ensure recording is fully stopped
                await new Promise(resolve => setTimeout(resolve, 200));
            }
            // End the conversation agent
            console.log('🛑 [VoiceChat] Ending conversation agent for session:', sessionToEnd, 'Reason:', reason);
            await this.conversationAgentService.endConversationAgent(sessionToEnd, reason);
            // Add delay to ensure backend cleanup is complete
            await new Promise(resolve => setTimeout(resolve, 300));
            this.cleanup();
            this.emitEnd();
        }
        catch (error) {
            console.error('Failed to end conversation:', error);
            component_2.NotificationsArea.sendNotification({
                content: 'conversation.end.failed',
                type: 'error'
            });
            // Force cleanup even on error
            this.cleanup();
        }
        finally {
            this.isLoading = false;
            this.updateIsReady(); // Ensure ready state is updated after loading is finished
        }
    }
    emitEnd() {
        this.$emit('voice-chat:conversation-end', { data: { messages: this.messages } });
    }
    handleConversationEnd(response) {
        this.endConversation('automatic');
    }
    async startRecording() {
        return recording_management_helper_1.RecordingManagementHelper.startRecording(this);
    }
    async stopRecording() {
        return recording_management_helper_1.RecordingManagementHelper.stopRecording(this);
    }
    handleStatusChange(status) {
        console.log('🔄 [VoiceChat] Status change:', status);
        switch (status) {
            case 'listening':
                this.userTurn = true;
                this.isThinking = false;
                this.isSpeaking = false;
                break;
            case 'thinking':
                this.userTurn = false;
                this.isThinking = true;
                this.isSpeaking = false;
                // STOP MICROPHONE when agent starts thinking
                console.log('🗣️ [VoiceChat] STAGE 1B: Agent thinking - STOPPING microphone');
                console.log('🛑 [VoiceChat] MICROPHONE DISABLED: Agent processing user input');
                if (this.isRecording && this.currentSessionId) {
                    this.conversationAgentService.stopAudioStreaming(this.currentSessionId).catch(error => {
                        console.error('❌ [VoiceChat] Error stopping audio during thinking:', error);
                    });
                    this.isRecording = false;
                    console.log('✅ [VoiceChat] Microphone stopped - agent thinking phase active');
                }
                break;
            case 'speaking':
                this.userTurn = false;
                this.isThinking = false;
                this.isSpeaking = true;
                break;
            case 'listening_restart':
                // Restart connection like stage transitions - no meaningful transcription received
                console.log('🔄 [VoiceChat] STAGE RESTART: Empty transcription - restarting connection');
                this.userTurn = true;
                this.isThinking = false;
                this.isSpeaking = false;
                // Stop current recording if active
                if (this.isRecording && this.currentSessionId) {
                    this.conversationAgentService.stopAudioStreaming(this.currentSessionId).catch(error => {
                        console.error('❌ [VoiceChat] Error stopping audio during restart:', error);
                    });
                    this.isRecording = false;
                }
                // Restart connection after a short delay to allow cleanup
                setTimeout(() => {
                    console.log('🔄 [VoiceChat] Reconnecting after empty transcription...');
                    this.startConversation();
                }, 500);
                break;
        }
    }
    cleanup() {
        this.isConversationActive = false;
        this.currentSessionId = null;
        this.currentConversationId = null; // Clear conversation ID to prevent reuse
        // Clear transcription state
        recording_management_helper_1.RecordingManagementHelper.clearTranscriptionState(this);
        // Stop audio streaming if active
        if (this.isRecording) {
            recording_management_helper_1.RecordingManagementHelper.stopRecording(this);
        }
        // Stop any audio playback
        response_audio_playback_helper_1.ResponseAudioPlaybackHelper.stopPlayback(this);
        // Stop audio analysis
        audio_analysis_helper_1.AudioAnalysisHelper.stopAudioAnalysis(this);
        this.cleanupMediaDevices();
        this.updateIsReady();
    }
    setVolume(volume) {
        response_audio_playback_helper_1.ResponseAudioPlaybackHelper.setVolume(this, volume);
    }
    updateIsReady() {
        // Component is ready when connected, has valid model or avatar selection, and not in error state
        // Loading state should not affect readiness for transcription handling
        this.isReady = !this.errorMessage && this.isConnected && !this.isConnecting && this.hasValidSelection;
    }
    cleanupMediaDevices() {
        // Voice stream package handles media device cleanup internally
        // Just update the component state
        this.updateIsReady();
    }
    /**
     * Update voice for the conversation
     * Note: This will take effect on the next conversation start
     */
    voiceIdChanged() {
        azure_voices_helper_1.AzureVoicesHelper.handleVoiceChange(this);
    }
    /**
     * Refresh language from the translation system
     * This can be called when the app language changes
     */
    refreshLanguage() {
        const currentLang = (0, trans_1.getCurrentLanguage)();
        if (currentLang !== this.language) {
            this.language = currentLang;
            // Reload voices for new language
            azure_voices_helper_1.AzureVoicesHelper.loadAzureVoices(this);
        }
    }
};
exports.VoiceChatComponent = VoiceChatComponent;
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "avatar", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "model", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "conversationId", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "language", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "knowledgeIds", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "writingStyleIds", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "promptSlots", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_d = typeof IAvatar_1.default !== "undefined" && IAvatar_1.default) === "function" ? _d : Object)
], VoiceChatComponent.prototype, "avatarSelected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isConnected", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isConversationActive", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isRecording", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isSpeaking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], VoiceChatComponent.prototype, "messages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "currentSessionId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], VoiceChatComponent.prototype, "currentConversationId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "errorMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], VoiceChatComponent.prototype, "volume", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isReady", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isVoiceStreaming", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_e = typeof Array !== "undefined" && Array) === "function" ? _e : Object)
], VoiceChatComponent.prototype, "userTranscriptions", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], VoiceChatComponent.prototype, "currentTranscription", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "partialTranscription", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], VoiceChatComponent.prototype, "isConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_f = typeof chatSettings_types_1.IChatSettings !== "undefined" && chatSettings_types_1.IChatSettings) === "function" ? _f : Object)
], VoiceChatComponent.prototype, "chatSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], VoiceChatComponent.prototype, "userTurn", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], VoiceChatComponent.prototype, "isThinking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], VoiceChatComponent.prototype, "agentSpeaking", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], VoiceChatComponent.prototype, "baseY", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], VoiceChatComponent.prototype, "equalizerLevels", void 0);
exports.VoiceChatComponent = VoiceChatComponent = __decorate([
    (0, client_1.RWSView)('voice-chat', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(ConversationAgentService_1.default)),
    __param(1, (0, client_1.RWSInject)(client_1.ApiService)),
    __param(2, (0, client_1.RWSInject)(StorageService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof ConversationAgentService_1.ConversationAgentServiceInstance !== "undefined" && ConversationAgentService_1.ConversationAgentServiceInstance) === "function" ? _a : Object, typeof (_b = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _b : Object, typeof (_c = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _c : Object])
], VoiceChatComponent);
VoiceChatComponent.defineComponent();
